"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHuaweiVersionNumber = exports.getForceUpdateStatus = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getForceUpdateStatus() {
    return (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query {\n      mobileAppConfigs {\n        id\n        forceUpdate\n        createdAt\n        updatedAt\n        ios\n        android\n        huawei\n      }\n    }\n  "], ["\n    query {\n      mobileAppConfigs {\n        id\n        forceUpdate\n        createdAt\n        updatedAt\n        ios\n        android\n        huawei\n      }\n    }\n  "])));
}
exports.getForceUpdateStatus = getForceUpdateStatus;
function getHuaweiVersionNumber() {
    return (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    query {\n      getHuaweiVersionNumber\n    }\n  "], ["\n    query {\n      getHuaweiVersionNumber\n    }\n  "])));
}
exports.getHuaweiVersionNumber = getHuaweiVersionNumber;
var templateObject_1, templateObject_2;
